import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vfs-card-view-new',
  templateUrl: './card-view-new.component.html',
  styleUrls: ['./card-view-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CardViewNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
